import React from 'react';
import { UserButton } from '@clerk/clerk-react';

interface HeaderProps {
  currentDate: Date;
  onDateChange: (days: number) => void;
  onToday: () => void;
  onSettingsOpen: () => void;
}

const Header: React.FC<HeaderProps> = ({ currentDate, onDateChange, onToday, onSettingsOpen }) => {
  const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  };

  return (
    <div className="header">
      <div className="header-top">
        <div className="header-spacer"></div>
        <div className="date-display">
          {formatDate(currentDate)}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <button className="settings-btn" onClick={onSettingsOpen}>
            ⚙️
          </button>
          <UserButton afterSignOutUrl="/sign-in" />
        </div>
      </div>
      <div className="date-navigation">
        <button className="nav-btn" onClick={() => onDateChange(-1)}>
          <span className="nav-btn-full">← Previous Day</span>
          <span className="nav-btn-mobile">← Prev</span>
        </button>
        <button className="nav-btn" onClick={onToday}>
          Today
        </button>
        <button className="nav-btn" onClick={() => onDateChange(1)}>
          <span className="nav-btn-full">Next Day →</span>
          <span className="nav-btn-mobile">Next →</span>
        </button>
      </div>
    </div>
  );
};

export default Header;